import {
    IQuestionnaireSection, EnumQuestionType, EmptyAnswer, JaNeinData, NumberRegex, DecimalRegex, EnumFreeTextType,
    IQuestionnaireSubSection, EnumSectionType, EnumRequiredGroup
} from './questionnaire.model';
import { BeschwerdebildOptions } from './questionnaire.data';

export const YES = "Ja";
export const NO = "Nein";

export const BTN_NEXT = "weiter";
export const BTN_END = "Befragung Beenden";

export const YES_PROBLEMS = "Ja, ich hatte bereits Probleme";
export const NO_PROBLEMS = "Nein, ich hatte keine Probleme";
export const NO_LICENSE = "Nein, ich besitze keinen Führerschein";

export const CANNABIS_INTAKE_SCHEDULE_QUESTION = 'Nehmen Sie das Cannabisarzneimittel täglich in einem festen Schema und/oder bei Bedarf ein?';

export const DAILY_SCHEMA = "Täglich in einem festen Schema";
export const ON_DEMAND = "Nur bei Bedarf";
export const BOTH = "In einem festen Schema und bei Bedarf";

export const QuestCannabisarzneimittelTitle = `Welche Cannabisarzneimittel nehmen Sie AKTUELL ein?`;
export const CANNABIS_ADDITIONAL_MEDICATION_QUESTION = 'Nehmen Sie aktuell noch weitere Cannabisarzneimittel ein?';

export const FREIZEIT_TEXT = "Ich habe bereits Cannabis im Sinne eines Freizeitkonsums aufgenommen, bevor ich Cannabisarzneimittel verschrieben bekommen habe";

export const NONE_OPTION = 'Keine Effekte neben der gewünschten Symptomlinderung';


export const generateSvgRating = (count = 1): string => {
    let svg = '';
    for (let i = 0; i < count; i++) {
        svg += `
      <span class="svg-circle">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
        </svg>
      </span>
    `;
    }
    return svg;
};

export const CannabisarzneimittelChoice = (number: 1 | 5 | 9 | 13 | 17): IQuestionnaireSubSection => {
    return {
        number: number,
        questions: [
            {
                number: 1,
                prefix: `Cannabis Choice ${number}`,
                title: QuestCannabisarzneimittelTitle,
                description: `Falls Sie mehr als ein Cannabisarzneimittel einnehmen, können Sie nach den Angaben des ersten Cannabisarzneimttels weitere benennen und Angaben machen.`,
                questionType: EnumQuestionType.CHOICE,
                answer: EmptyAnswer(),
                data: [
                    "Cannabisextrakt",
                    "Cannabisblüten",
                    "Anderes Cannabisarzneimittel"
                ],
                required: true
            }
        ]
    }
};

export const WeitereCannabisarzneimittelChoice = (number: number): IQuestionnaireSubSection => {
    return {
        number: number,
        questions: [
            {
                number: 1,
                prefix: `Cannabis Choice ${number}`,
                title: CANNABIS_ADDITIONAL_MEDICATION_QUESTION,
                questionType: EnumQuestionType.CHOICE,
                answer: EmptyAnswer(),
                data: JaNeinData,
                required: true
            }
        ]
    }
};

export const CannabisextraktSubSection = (number: 2 | 6 | 10 | 14 | 18): IQuestionnaireSubSection[] => {
    let prefix = `Cannabisextrakt`;
    let cannSubSection: IQuestionnaireSubSection[] = [];
    cannSubSection = [
        {
            number: number,
            title: `Bitte machen Sie konkrete Angaben zum verschriebenen Cannabisarzneimittel und zur Dosierung.`,
            questions: [
                {
                    number: 1,
                    prefix: prefix,
                    title: `Name des Extraktes`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    required: true,
                    hideDivider: true,
                    pattern: /^[A-Za-z]{3}.*$/
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `THC-Konzentration (mg/mL)`,
                    questionType: EnumQuestionType.INPUT,
                    pattern: /^(?:[0-9]|[1-9][0-9]|1[0-9]{2}|200)$/,
                    answer: EmptyAnswer(),
                    required: true,
                    hideDivider: true
                },
                {
                    number: 3,
                    prefix: prefix,
                    title: `CBD-Konzentration (mg/mL)`,
                    questionType: EnumQuestionType.INPUT,
                    pattern: /^(?:[0-9]|[1-9][0-9]|1[0-9]{2}|200)$/,
                    answer: EmptyAnswer(),
                    required: true,
                    info: {
                        position: 'END',
                        title: `Wo finde ich Angaben zu THC und CBD?`,
                        description: `In den meisten Fällen sind die THC- und ggf. CBD-Konzentrationen bereits im Namen des Cannabisarzneimittels enthalten.
                                        <br/><br/>
                                        Bei Cannabisextrakten werden die Werte in mg/ml angegeben, z. B.:<br/>
                                        „20/6“ = 20 mg/ml THC und 6 mg/ml CBD.
                                        <br/><br/>
                                        Falls dies nicht direkt ersichtlich ist, finden Sie die Angaben auf Rezept oder Verpackung.`
                    }
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Auf welche Weise nehmen Sie das Cannabisarzneimittel ein?`,
                    questionType: EnumQuestionType.CHOICE,
                    answer: EmptyAnswer(),
                    required: true,
                    data: [
                        "Milliliter (1 mL Dosierspritze)",
                        "Hübe (Dosierpumpe)",
                        "Tropfen (Tropfpipette)"
                    ]
                },
                {
                    number: 5,
                    prefix: prefix,
                    title: CANNABIS_INTAKE_SCHEDULE_QUESTION,
                    questionType: EnumQuestionType.CHOICE,
                    answer: EmptyAnswer(),
                    required: true,
                    data: [DAILY_SCHEMA, ON_DEMAND, BOTH]
                }
            ]
        },
        {
            number: number + 1,
            questions: [
                {
                    number: 1,
                    introText: `Dosierung bei täglicher Einnahme in einem festen Schema`,
                    prefix: prefix,
                    title: `Morgens`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisextrakt
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `Mittags`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisextrakt
                },
                {
                    number: 3,
                    prefix: prefix,
                    title: `Abends`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisextrakt
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Zur Nacht`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisextrakt
                },
                {
                    number: 5,
                    prefix: prefix,
                    introText: `Dosierung bei Bedarf`,
                    title: `Einzeldosierung`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: /^(100(\.0+)?|([1-9]?\d(\.\d+)?|0\.(0[5-9]|[1-9]\d)))$/,
                    required: true,
                    hideDivider: true,
                    hidden: true
                },
                {
                    number: 6,
                    prefix: prefix,
                    title: `Häufigkeit im Durchschnitt pro Woche`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    required: true,
                    hidden: true
                }
            ]
        }
    ]

    const HAS_NEXT_MEDICATION = new Set([2, 6, 10, 14]);
    if (HAS_NEXT_MEDICATION.has(number)) {
        cannSubSection.push(WeitereCannabisarzneimittelChoice(number + 2));
    }
    return cannSubSection;
}

export const CannabisblutenSubSection = (number: 2 | 6 | 10 | 14 | 18): IQuestionnaireSubSection[] => {
    let prefix = `Cannabisblüten`;
    let cannSubSection: IQuestionnaireSubSection[] = [];
    cannSubSection = [
        {
            number: number,
            title: `Bitte machen Sie konkrete Angaben zum verschriebenen Cannabisarzneimittel und zur Dosierung.`,
            questions: [
                {
                    number: 1,
                    prefix: prefix,
                    title: `Cannabisblüten (Name wie auf Rezept)`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    required: true,
                    hideDivider: true,
                    pattern: /^[A-Za-z]{3}.*$/
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `THC-Konzentration (in Prozent)`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    required: true,
                    hideDivider: true,
                    pattern: /^(?:[0-9]|[1-3][0-9]|40)$/
                },
                {
                    number: 3,
                    prefix: prefix,
                    title: `CBD-Konzentration (in Prozent)`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    required: true,
                    pattern: /^(?:[0-9]|[1-3][0-9]|40)$/,
                    info: {
                        position: 'END',
                        title: `Wo finde ich Angaben zu THC und CBD?`,
                        description: `Bei Cannabisblüten sind die THC- und ggf. CBD-Konzentrationen meist bereits im Namen des Arzneimittels enthalten.
                    <br/><br/>
Die Werte werden als Prozentangaben dargestellt, z. B.:<br/>
„Cannabisblüte XY 20/1“ = 20 % THC und 1 % CBD.
<br/><br/>
Falls dies nicht direkt ersichtlich ist, finden Sie die Angaben auch auf Ihrem Rezept oder Ihrer Verpackung.`
                    }
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Auf welche Weise nehmen Sie die Cannabisblüten vorwiegend ein?`,
                    questionType: EnumQuestionType.CHOICE,
                    answer: EmptyAnswer(),
                    data: [
                        "Vaporisieren",
                        "Rauchen als Joint",
                        "Rauchen mit Bong / Pfeife",
                        "Essbare Darreichung oder als Tee"
                    ],
                    required: true
                },
                {
                    number: 5,
                    prefix: prefix,
                    title: CANNABIS_INTAKE_SCHEDULE_QUESTION,
                    questionType: EnumQuestionType.CHOICE,
                    answer: EmptyAnswer(),
                    data: [DAILY_SCHEMA, ON_DEMAND, BOTH],
                    required: true
                }
            ]
        },
        {
            number: number + 1,
            questions: [
                {
                    number: 1,
                    prefix: prefix,
                    introText: `Dosierung bei täglicher Einnahme in einem festen Schema`,
                    title: `Milligramm Cannabisblüten pro Anwendung`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: /^(1000|[1-9]?\d{1,2}|0)$/,
                    required: true,
                    hideDivider: true,
                    hidden: true
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `Anzahl Anwendungen pro Tag`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: /^(?:[0-9]|[1-4][0-9]|50)$/,
                    required: true,
                    hidden: true
                },
                {
                    number: 3,
                    prefix: prefix,
                    introText: `Dosierung bei Bedarf`,
                    title: `Einzeldosierung <br/>(Milligramm Cannabisblüten pro Anwendung)`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: /^(1000|[1-9]?\d{1,2}|0)$/,
                    required: true,
                    hidden: true,
                    hideDivider: true
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Häufigkeit im Durchschnitt pro Woche`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    required: true,
                    hidden: true
                }
            ]
        }
    ]

    const HAS_NEXT_MEDICATION = new Set([2, 6, 10, 14]);
    if (HAS_NEXT_MEDICATION.has(number)) {
        cannSubSection.push(WeitereCannabisarzneimittelChoice(number + 2));
    }
    return cannSubSection;
}

export const CannabisarzneimittelSubSection = (number: 2 | 6 | 10 | 14 | 18): IQuestionnaireSubSection[] => {
    let prefix = `Cannabisarzneimittel`;
    let cannSubSection: IQuestionnaireSubSection[] = [];
    cannSubSection = [
        {
            number: number,
            title: `Bitte machen Sie konkrete Angaben zum verschriebenen Cannabisarzneimittel und zur Dosierung.`,
            questions: [
                {
                    number: 1,
                    prefix: prefix,
                    title: `Cannabisarzneimittel`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    required: true,
                    hideDivider: true,
                    pattern: /^[A-Za-z]{3}.*$/
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `THC-Konzentration`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true
                },
                {
                    number: 3,
                    prefix: prefix,
                    title: `CBD-Konzentration`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Auf welche Weise nehmen Sie das Cannabisarzneimittel ein?`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer()
                },
                {
                    number: 5,
                    prefix: prefix,
                    title: CANNABIS_INTAKE_SCHEDULE_QUESTION,
                    questionType: EnumQuestionType.CHOICE,
                    answer: EmptyAnswer(),
                    required: true,
                    data: [DAILY_SCHEMA, ON_DEMAND, BOTH]
                }
            ]
        },
        {
            number: number + 1,
            questions: [
                {
                    number: 1,
                    introText: `Dosierung bei täglicher Einnahme in einem festen Schema`,
                    prefix: prefix,
                    title: `Morgens`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisarzneimittel
                },
                {
                    number: 2,
                    prefix: prefix,
                    title: `Mittags`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisarzneimittel
                },
                {
                    number: 3,
                    prefix: prefix,
                    title: `Abends`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hideDivider: true,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisarzneimittel
                },
                {
                    number: 4,
                    prefix: prefix,
                    title: `Zur Nacht`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    hidden: true,
                    requiredGroup: EnumRequiredGroup.Cannabisarzneimittel
                },
                {
                    number: 5,
                    introText: `Dosierung bei Bedarf`,
                    prefix: prefix,
                    title: `Einzeldosierung`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    required: true,
                    hideDivider: true,
                    hidden: true
                },
                {
                    number: 6,
                    prefix: prefix,
                    title: `Häufigkeit im Durchschnitt pro Woche`,
                    questionType: EnumQuestionType.INPUT,
                    answer: EmptyAnswer(),
                    pattern: DecimalRegex,
                    required: true,
                    hidden: true
                }
            ]
        }
    ]

    const HAS_NEXT_MEDICATION = new Set([2, 6, 10, 14]);
    if (HAS_NEXT_MEDICATION.has(number)) {
        cannSubSection.push(WeitereCannabisarzneimittelChoice(number + 2));
    }
    return cannSubSection;
}

export const NebeneffektenSubSection = (label: string, num: number): IQuestionnaireSubSection => {
    let subSection: IQuestionnaireSubSection = {
        number: num,
        title: `Angaben zu den Nebeneffekten`,
        answerValue: label,
        questions: [
            {
                number: 1,
                prefix: label,
                title: `Spüren Sie aktuell den Nebeneffekt nach Einnahme des Medikaments?`,
                questionType: EnumQuestionType.CHOICE,
                answer: EmptyAnswer(),
                data: JaNeinData,
                required: true
            },
            {
                number: 2,
                prefix: label,
                title: `Wann trat der Nebeneffekt <u>erstmalig</u> auf?`,
                questionType: EnumQuestionType.CHOICE,
                answer: EmptyAnswer(),
                data: [
                    "Zu Beginn der Therapie",
                    "Nach Dosissteigerung",
                    "Bei konstanter Therapie"
                ],
                required: true
            },
            {
                number: 3,
                prefix: label,
                title: `Im Verlauf trat (oder tritt) der Nebeneffekt…`,
                questionType: EnumQuestionType.CHOICE,
                answer: EmptyAnswer(),
                data: [
                    "nur zu Beginn der Therapie auf",
                    "nur nach Dosissteigerung auf",
                    "ab und zu auf",
                    "durchgehend auf"
                ],
                required: true
            },
            {
                number: 4,
                prefix: label,
                title: `Bitte geben Sie an, wie stark der Nebeneffekt Sie beeinträchtigt.`,
                description: `${generateSvgRating(1)} = keine Beeinträchtigung – ${generateSvgRating(4)} = sehr starke Beeinträchtigung`,
                questionType: EnumQuestionType.RATING,
                answer: EmptyAnswer(),
                required: true,
                extraClass: {
                    description: 'svg-rating-block'
                }
            },
            {
                number: 5,
                prefix: label,
                title: `Wie haben Sie den Nebeneffekt gefühlt wahrgenommen?`,
                description: `${generateSvgRating(1)} = sehr angenehm – ${generateSvgRating(4)} = sehr unangenehm`,
                questionType: EnumQuestionType.RATING,
                answer: EmptyAnswer(),
                required: true,
                extraClass: {
                    description: 'svg-rating-block'
                }
            }
        ]
    }
    return subSection;
}


export const QuestionnaireJSON: IQuestionnaireSection[] = [
    {
        number: 1,
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: `Ich nehme zur Kenntnis, dass die erhobenen Daten und Ergebnisse für wissenschaftliche Publikationen genutzt werden und dass dies in anonymisierter Form geschieht, sodass keine Rückschlüsse auf meine Person möglich sind.`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    },
                    {
                        number: 2,
                        introText: `Diese Befragung richtet sich ausschließlich an Patienten:innen, die mit einem Cannabisarzneimittel therapiert werden.`,
                        title: `Wurde Ihnen ein Cannabisarzneimittel ärztlich verschrieben?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    }
                ]
            },
            {
                number: 2,
                questions: [
                    {
                        number: 1,
                        title: `Bitte geben Sie Ihr biologisches Geschlecht an`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: ["weiblich", "männlich", "keine Angabe"],
                        required: true
                    },
                    {
                        number: 2,
                        title: `Bitte geben Sie Ihr Geburtsjahr an`,
                        questionType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        placeholder: `z.B. 1980`,
                        pattern: /^(19|20)\d{2}$/,
                        required: true
                    },
                    {
                        number: 3,
                        title: `Bitte geben Sie die ersten drei Ziffern Ihrer Postleitzahl an`,
                        questionType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        placeholder: `011-999`,
                        pattern: /^(0[1-9][1-9]|[1-9][0-9]{2})$/,
                        required: true
                    }
                ]
            },
            {
                number: 3,
                questions: [
                    {
                        number: 1,
                        title: `Werden die Kosten der Cannabisarzneimittel durch Ihre gesetzliche oder private Krankenversicherung erstattet?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    },
                    {
                        number: 2,
                        title: `Durch wen wurden Ihnen Cannabisarzneimittel verschrieben?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: [
                            "Fachärztliche Verschreibung (persönlicher Kontakt)",
                            "Allgemeinärztliche Verschreibung (Hausarzt/-ärztin, persönlicher Kontakt)",
                            "Verschreibung über Online-Portal mit ärztlichem Kontakt über Videosprechstunde",
                            "Verschreibung über Online-Portal mit medizinischem Fragebogen"
                        ],
                        required: true
                    }
                ]
            }
        ]
    },
    {
        number: 2,
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        introText: `Für welches Beschwerdebild / welche Erkrankung wurde Ihnen ein Cannabisarzneimittel verschrieben?`,
                        title: `Beschwerdebild`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: [
                            "Schmerzen",
                            "Psychische Erkrankungen",
                            "Neurologische Krankheitsbilder",
                            "Frauengesundheit",
                            "Weitere Erkrankungen"
                        ],
                        required: true,
                        conditionalOptions: {
                            dependedKey: "Beschwerdebild"
                        }
                    }

                ]
            },
            {
                number: 2,
                questions: [
                    {
                        number: 1,
                        title: `Wählen Sie bitte die Erkrankung aus, die mit dem Cannabisarzneimittel behandelt wird.`,
                        questionType: EnumQuestionType.DROPDOWN,
                        answer: EmptyAnswer(),
                        data: [],
                        required: true,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        conditionalOptions: {
                            dependedKey: "Beschwerdebild",
                            options: BeschwerdebildOptions
                        }
                    },
                    {
                        number: 2,
                        title: `Seit wann verwenden Sie Cannabisarzneimittel für diese Erkrankung?`,
                        questionType: EnumQuestionType.MONTH,
                        answer: EmptyAnswer(),
                        placeholder: `Datum (Monat/Jahr)`,
                        data: [],
                        required: true
                    }
                ]
            }
        ]
    },
    {
        number: 3,
        subSections: [CannabisarzneimittelChoice(1)]
    },
    {
        number: 4,
        subSections: [
            {
                number: 1,
                sectionType: EnumSectionType.Nebeneffekte,
                required: true,
                questions: [
                    {
                        number: 1,
                        title: `Nebeneffekte nach Aufnahme von Cannabisarzneimitteln`,
                        description: `Treten (oder traten) bei der Therapie erwünschte oder unerwünschte Begleiterscheinungen neben der Symptomlinderung auf?
                                <br/><br/>
                                Wählen Sie bitte hier Wirkungen aus, die unter der Therapie mit Cannabisarzneimitteln aufgetreten sind:`,
                        questionType: EnumQuestionType.CHOICE,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [NONE_OPTION]
                    },
                    {
                        number: 2,
                        title: `Auswirkungen auf Psyche und Wahrnehmung`,
                        questionType: EnumQuestionType.CHOICE,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [
                            "Müdigkeit oder Schläfrigkeit",
                            "Gestörte Zeitwahrnehmung (z.B. Zeit vergeht langsamer/schneller)",
                            "Sinnestäuschungen, Halluzinationen, Dissoziation (außerkörperliche Erfahrung)",
                            "Euphorisierung im Sinne eines ‘High’-Gefühls (gehobene Stimmungslage)",
                            "Gesteigertes Selbstbewusstsein, gefühlte Überlegenheit",
                            "Depressive Verstimmung",
                            "Antriebsminderung, Teilnahmslosigkeit, Gleichgültigkeit",
                            "Desorientierung (z.B. zu Person, Raum, Zeit), Verwirrung",
                            "Konzentrationsstörung und erhöhte Ablenkbarkeit",
                            "Gedächtnisstörung (z.B. Vergesslichkeit, Lernschwierigkeiten)",
                            "Ängste oder Panik, bis hin zu Wahnvorstellungen",
                            "Verlangsamte Reaktion",
                            "Schwindel oder Gleichgewichtsstörungen"
                        ]
                    },
                    {
                        number: 3,
                        title: `Auswirkungen auf die Augen`,
                        questionType: EnumQuestionType.CHOICE,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [
                            "Erhöhte Blendempfindlichkeit",
                            "Verschwommenes Sehen, Doppelbilder",
                            "Probleme beim Verfolgen von bewegten Objekten",
                            "Gesichtsfeldeinengung (“Tunnelblick”)",
                            "Störungen der Farbwahrnehmung",
                            "Gerötete Augen"
                        ]
                    },
                    {
                        number: 4,
                        title: `Körperliche Nebeneffekte`,
                        questionType: EnumQuestionType.CHOICE,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [
                            "Magen-Darm-Beschwerden (z.B. Übelkeit, Erbrechen, Durchfall, Verstopfung)",
                            "Mundtrockenheit",
                            "Appetitsteigerung bzw. Gewichtszunahme",
                            "Appetitminderung bzw. Gewichtsabnahme",
                            "Kopfschmerzen",
                            "Sprachschwierigkeiten (z.B. verwaschene Aussprache)",
                            "Verändertes Schriftbild",
                            "Zittrigkeit",
                            "Gangschwierigkeiten",
                            "Beeinträchtigte Koordination (z.B. Hand-Auge Koordination)",
                            "Herz-Kreislauf-Beschwerden"
                        ]
                    }
                ]
            }
        ]
    },
    {
        number: 5,
        hidden: true,
        subSections: []
    },
    {
        number: 6,
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: `Teilnahme am Straßenverkehr`,
                        description: `Hatten Sie wegen Ihrer Cannabismedikation schon einmal Probleme mit dem Führerschein?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: [YES_PROBLEMS, NO_PROBLEMS, NO_LICENSE],
                        required: true
                    }
                ]
            },
            {
                number: 2,
                hidden: true,
                questions: [
                    {
                        number: 1,
                        title: `In welchem Rahmen traten diese Probleme auf?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: [
                            "Allgemeine Verkehrskontrolle (anlassunabhängig)",
                            "Verkehrskontrolle aufgrund von Fahrauffälligkeiten",
                            "Verkehrsunfall"
                        ],
                        required: true
                    },
                    {
                        number: 2,
                        title: `Wurde Ihnen der Führerschein entzogen, da aufgrund Ihrer Cannabismedikation THC im Blut nachgewiesen wurde?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    }
                ]
            },
            {
                number: 3,
                hidden: true,
                questions: [
                    {
                        number: 1,
                        title: `Nehmen Sie bzw. haben Sie in der Einstellungsphase ihrer Therapie am Straßenverkehr mit einem Fahrzeug teilgenommen?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    },
                    {
                        number: 2,
                        title: `Nehmen Sie aktuell am Straßenverkehr mit einem Fahrzeug teil?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true
                    }
                ]
            },
            {
                number: 4,
                title: `Wie lange warten Sie üblicherweise nach Aufnahme von Cannabisarzneimitteln, bevor Sie am Straßenverkehr teilnehmen?`,
                questions: [
                    {
                        number: 1,
                        title: `Minuten`,
                        questionType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        pattern: NumberRegex,
                        required: true,
                        hidden: true
                    },
                    {
                        number: 2,
                        introText: `Nehmen Sie Beeinträchtigungen Ihrer Fähigkeiten zur Straßenverkehrsteilnahme wahr?`,
                        title: `Nach der von Ihnen angegebenen Wartezeit`,
                        description: `${generateSvgRating(1)} = keine Beeinträchtigung – ${generateSvgRating(4)} = sehr starke Beeinträchtigung`,
                        questionType: EnumQuestionType.RATING,
                        answer: EmptyAnswer(),
                        required: true,
                        hideDivider: true,
                        hidden: true
                    },
                    {
                        number: 3,
                        title: `Wenn sie theoretisch die Wartezeit nicht einhalten würden`,
                        description: `${generateSvgRating(1)} = keine Beeinträchtigung – ${generateSvgRating(4)} = sehr starke Beeinträchtigung`,
                        questionType: EnumQuestionType.RATING,
                        answer: EmptyAnswer(),
                        required: true,
                        hideDivider: true,
                        hidden: true
                    },
                    {
                        number: 4,
                        title: `Nehmen Sie direkt nach der Aufnahme Beeinträchtigungen Ihrer Fähigkeiten zur Straßenverkehrsteilnahme wahr?`,
                        description: `${generateSvgRating(1)} = keine Beeinträchtigung – ${generateSvgRating(4)} = sehr starke Beeinträchtigung`,
                        questionType: EnumQuestionType.RATING,
                        answer: EmptyAnswer(),
                        required: true,
                        hidden: true
                    },
                    {
                        number: 5,
                        title: `Hatten Sie schon mal den Eindruck, nicht lange genug gewartet zu haben, bevor Sie am Straßenverkehr teilgenommen haben?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: JaNeinData,
                        required: true,
                        hidden: true
                    },
                    {
                        number: 6,
                        title: `Warum haben sie nicht lange genug warten können?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        data: [
                            "Wegen eines dringenden Termins",
                            "Da ich davon ausging, keine Beeinträchtigungen zu spüren",
                            "Ich ging davon aus, trotz leichter Beeinträchtigungen, sicher fahren zu können",
                            "Ich hatte keine andere Option (Öffentlicher Nahverkehr, Taxi oder Uber)",
                            "Die anderen Transportoptionen waren zu schwierig (lange Wartezeit, zu teuer)"
                        ],
                        required: true,
                        hidden: true
                    },
                    {
                        number: 7,
                        title: `Freiwillige Angabe: Anmerkungen zur Straßenverkehrsteilnahme unter der Therapie mit Cannabisarzneimitteln`,
                        questionType: EnumQuestionType.TEXTAREA,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 8,
                        title: `Wie sind Sie von dem verschreibenden Arzt oder der verschreibenden Ärztin über ein mögliches Risiko bei der Teilnahme am Straßenverkehr bei Einnahme von Cannabisarzneimitteln aufgeklärt worden?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        required: true,
                        data: [
                            "Ich wurde in einem persönlichen Gespräch umfassend aufgeklärt und habe mit einer Unterschrift bestätigt, dass ich die Hinweise zu dem Risiko gelesen und verstanden habe",
                            "Ich bin in einem persönlichen Gespräch mündlich aufgeklärt worden",
                            "Mir wurde ein Informationsblatt überreicht (ohne ein persönliches Gespräch)",
                            "Während des Bestellprozesses wurden online Hinweise auf das Risiko angezeigt",
                            "Ich wurde weder schriftlich noch mündlich über das Risiko aufgeklärt",
                            "Ich bin mir nicht sicher"
                        ]
                    },
                    {
                        number: 9,
                        title: `Sind Sie von Ihrem Arzt/Ihrer Ärztin Ihrer Meinung nach ausreichend über ein mögliches Risiko bei der Teilnahme am Straßenverkehr aufgeklärt worden?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        required: true,
                        data: JaNeinData
                    }
                ]
            }
        ]
    },
    {
        number: 7,
        subSections: [
            {
                number: 1,
                title: `Vorerfahrung mit Cannabis`,
                button: {
                    text: BTN_END
                },
                questions: [
                    {
                        number: 1,
                        title: `Welche der folgenden Aussagen beschreibt ihr Verhältnis zu Cannabis am besten, bevor Sie Cannabisarzneimittel verschrieben bekommen haben?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        required: true,
                        data: [
                            "Bevor ich Cannabisarzneimittel verordnet bekommen habe, habe ich noch nie Cannabis konsumiert",
                            "Ich habe Cannabis im Sinne des Versuchs einer Selbsttherapie aufgenommen, bevor ich Cannabisarzneimittel verschrieben bekommen habe",
                            "Ich habe Cannabis lediglich vor Jahren im Sinne eines Probierkonsums aufgenommen",
                            FREIZEIT_TEXT
                        ]
                    }
                ]
            },
            {
                number: 2,
                hidden: true,
                button: {
                    text: BTN_END
                },
                questions: [
                    {
                        number: 1,
                        title: `Wie oft nahmen Sie Cannabis im Sinne eines Freizeitkonsums durchschnittlich auf, bevor Sie Cannabisarzneimittel verschrieben bekommen haben? <br/><br/> Zeiteinheit`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        required: true,
                        data: [
                            "Woche",
                            "Monat",
                            "Jahr"
                        ]
                    },
                    {
                        number: 2,
                        title: `Anzahl Tage pro Zeiteinheit`,
                        questionType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        pattern: NumberRegex,
                        required: true
                    },
                    {
                        number: 3,
                        title: `Haben Sie seit Ihrem Therapiebeginn mit einem Cannabisarzneimittel noch einmal zusätzlich nicht-medizinisches Cannabis bzw. Cannabis zu nicht-medizinischen Zwecken konsumiert?`,
                        questionType: EnumQuestionType.CHOICE,
                        answer: EmptyAnswer(),
                        required: true,
                        data: JaNeinData
                    },
                    {
                        number: 4,
                        title: `Schätzen Sie ein, wie viel Prozent Ihrer GESAMTEN Cannabisaufnahme aktuell medizinischen Zwecken entspricht (0-100 %).`,
                        questionType: EnumQuestionType.SCALE,
                        answer: EmptyAnswer(),
                        required: true,
                        hidden: true,
                        scaleOption: {
                            floor: 0,
                            ceil: 100,
                            step: 10,
                            translate: '%',
                            label: {
                                start: `Freizeitkonsum`,
                                end: `Medizinische Zwecke`
                            }
                        }
                    }
                ]
            }
        ]
    }
];
